






















import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import { DonutChart } from 'vue-morris';
import dataProxy from '@/services/data-proxy.service'
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {Dashboard} from "@/services/BackendProxies";

@Component({components: {DonutChart}})
export default class UcesceTroskova extends mixins(ComponentBaseMixin) {
    colors = [ "#FF6384", "#36A2EB", "#FFCE56", "#8892d6", "#45bbe0" ];
    data = [];
    godine = [];
    godina = 0;
    @Prop() dashboard!: Dashboard;

    @Watch('dashboard')
    onDashboardChanged(dashboard: Dashboard) {
        this.godine = Object.keys(this.dashboard.ucesceUUkupnimTroskovima).sort((a, b) => -a.localeCompare(b));
        if (this.godine.length) {
            this.godina = this.godine[0];
        }
    }

    @Watch('godina')
    onGodinaChanged(godina) {
        const ukupniTroskovi = this.dashboard.ucesceUUkupnimTroskovima[godina];
        const data = [];
        for (let key in ukupniTroskovi) {
            const value = ukupniTroskovi[key];
            if (typeof value == "number" && key != 'sum') {
                data.push({label: this.$i18n.t(key), value: Math.round(value)});
            }
        }
        this.data = data;
    }
}
